// services/analytics.ts
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, Analytics } from "firebase/analytics";
import { CookieManager } from '../utils/CookieManager';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };

class AnalyticsService {
  private analytics: Analytics | null = null;
  private initialized = false;

  initialize() {
    if (this.initialized) return;
    this.initialized = true;

    if (!firebaseConfig.projectId) return;

    try {
      const app = initializeApp(firebaseConfig);
      this.analytics = getAnalytics(app);
      CookieManager.registerAnalytics(this.analytics);
    } catch {
      // Firebase unavailable — analytics disabled
    }
  }

  trackEvent(eventName: string, eventParams?: Record<string, any>) {
    if (this.analytics && CookieManager.isAnalyticsAvailable()) {
      logEvent(this.analytics, eventName, eventParams);
    }
  }

  getInstance() {
    if (!this.initialized) {
      this.initialize();
    }
    return this.analytics;
  }
}

export const analyticsService = new AnalyticsService();